<template>
    
    <div class="main">
        <form-turma :paramId="$route.params.id" v-on:onSubmitTurma="onSubmitTurma"></form-turma>
    </div>
    
</template>
<script>

import formTurma from "./form"

export default {
    methods:{

        onSubmitTurma(){

            this.$router.push('/admin/turma');  
        }
    },
    components:{ formTurma }
}
</script>
